'use strict';

class OriginatorCard {
}

const originatorCard = {
  bindings: {
    type: '<',
    originator: '<'
  },
  controller: OriginatorCard,
  template: `
    <!-- Domestic -->
    <div class="row originatorDetails" ng-if="$ctrl.type !== 'international'">

      <div class="columns large-4">
        <logo id="$ctrl.originator.id" />
      </div>

      <div class="columns large-8">
        <div>
          <strong>{{ $ctrl.originator.name }}</strong>
        </div>
        <div>
          {{ $ctrl.originator.contact.address.address1 }}
        </div>
        <div>
          {{ $ctrl.originator.contact.address.address2 }}
        </div>
        <div>
          {{ $ctrl.originator.contact.address.zip }}
          {{ $ctrl.originator.contact.address.city }}
        </div>
        <div>
          {{ $ctrl.originator.contact.address.country }}
        </div>

        <div class="contactDetails">
          <div ng-show="$ctrl.originator.contact.phone">
            Tlf: {{ $ctrl.originator.contact.phone }}
          </div>
          <div ng-show="$ctrl.originator.fax">
            Faks: {{ $ctrl.originator.contact.fax }}
          </div>
          <div ng-show="$ctrl.originator.bankAccount.number">
            Kontonr: {{ $ctrl.originator.bankAccount.number | accountNumberFormat }}
          </div>
          <div ng-show="$ctrl.originator.organisation.number">
            <span ng-show="$ctrl.originator.organisation.foretaksregisteret">
              Foretaksregisteret:
              <span class="orgNo">{{ $ctrl.originator.organisation.number | organisationNumberFormat }} <span class="orgNoSuffix" ng-show="$ctrl.originator.organisation.mvaregisteret">MVA</span>
            </span>
            </span>
            <span ng-hide="$ctrl.originator.organisation.foretaksregisteret">
              Organisasjonsnummer:
              <span class="orgNo">{{ $ctrl.originator.organisation.number | organisationNumberFormat }} <span class="orgNoSuffix" ng-show="$ctrl.originator.organisation.mvaregisteret">MVA</span></span>
            </span>
          </div>
          <div ng-show="$ctrl.originator.contact.email">
            E-post: {{ $ctrl.originator.contact.email }}
          </div>
          <div ng-show="$ctrl.originator.contact.web">
            Hjemmeside: {{ $ctrl.originator.contact.web }}
          </div>
        </div>

      </div>

    </div>

    <!-- International -->
    <div class="row originatorDetails international" ng-if="$ctrl.type === 'international'">

      <div class="columns large-8">
        <div>
          <strong>{{ $ctrl.originator.name }}</strong>
        </div>
        <div>
          {{ $ctrl.originator.contact.address.address1 }}
        </div>
        <div>
          {{ $ctrl.originator.contact.address.address2 }}
        </div>
        <div>
          {{ $ctrl.originator.contact.address.zip }}
          {{ $ctrl.originator.contact.address.city }}
        </div>
        <div>
          {{ $ctrl.originator.contact.address.country }}
        </div>

      </div>

      <div class="columns large-4 international">
        <div>
          <logo id="$ctrl.originator.id" />
        </div>

        <div class="contactDetails">
          <div>
            <strong>{{ $ctrl.originator.name }}</strong>
          </div>
          <div ng-show="$ctrl.originator.contact.phone">
            Tlf: {{ $ctrl.originator.contact.phone }}
          </div>
          <div ng-show="$ctrl.originator.contact.mobile">
            Mobil: {{ $ctrl.originator.contact.mobile }}
          </div>
          <div ng-show="originator.contact.fax">
            Faks: {{ $ctrl.originator.contact.fax }}
          </div>
          <div ng-show="$ctrl.originator.bankAccount.number">
            Kontonr: {{ $ctrl.originator.bankAccount.number }}
          </div>
          <div ng-show="$ctrl.originator.organisation.number">
            <span ng-show="$ctrl.originator.organisation.foretaksregisteret">
              Foretaksregisteret:
              <span class="orgNo">{{ $ctrl.originator.organisation.number }} <span class="orgNoSuffix" ng-show="$ctrl.originator.organisation.mvaregisteret">MVA</span>
            </span>
            </span>
            <span ng-hide="$ctrl.originator.organisation.foretaksregisteret">
              Organisasjonsnummer:
              <span class="orgNo">{{ $ctrl.originator.organisation.number }} <span class="orgNoSuffix" ng-show="$ctrl.originator.organisation.mvaregisteret">MVA</span>
            </span>
            </span>
          </div>
          <div ng-show="$ctrl.originator.contact.email">
            E-post: {{ $ctrl.originator.contact.email }}
          </div>
          <div ng-show="$ctrl.originator.contact.web">
            Hjemmeside: {{ $ctrl.originator.contact.web }}
          </div>
        </div>
      </div>

    </div>
  `
};

angular
  .module('SendRegning')
  .component('originatorDetails', originatorCard);
